import { cn } from "@/lib/utils"; // Ensure you have a utility for classNames
import { Button } from "@/components/ui/button"; // Adjust the import path based on your setup
import { Link, useLocation } from '@tanstack/react-router' // Using Next.js Link component for navigation
import { SummaryIcon, ListIcon, ReportIcon } from "@/components/icon"; // Importa tutto dal file index.ts
import { ProfileMenu } from "./profile-menu";
import type { Roles } from "@/people";
import { HasOverdue } from "@/components/tasks/has.overdue";
import { DownloadIcon, FactoryIcon, ListTodoIcon, UploadIcon, UserIcon } from "lucide-react";
import { getClosingDate } from "@/utils/closing-date";

interface TopBarProps {
  roles: Roles
}

export const TopBar = ({ roles }: TopBarProps) => {
  const { pathname } = useLocation()
  const isListPath = pathname.includes("/tasks");
  const isReportPath = pathname.includes("/report");
  const isSummaryPath = pathname.includes("/summary");
  const isGlobalSummary = pathname.includes("/global-summary");
  const isDeaadlineCorporate = pathname.includes("/key-deadline");
  const isUsersPath = pathname.includes("/users");
  const isManageTasksPath = pathname.includes("/manage-tasks");
  const isUpload = pathname.includes("/import");

  const closingDate = getClosingDate();
  return (
    <div className={cn("flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200")}>

      {/* Left: App Logo e TabNavigazione */}
      <div className="flex items-center gap-4">
        <div className="flex flex-col">
          <div className="flex items-center bg-black p-2 rounded-md">
            <img
              className="w-auto h-5"
              src="EssilorLuxotticaWhite.svg" // Replace with your logo path
              alt="App Logo"
              width={120} // Adjust size as needed
              height={60} // Adjust size as needed
            />
          </div>
          <div className="text-normal font-Avenir text-black flex items-center">
            <span className="inline-flex mr-3">
              <span className="h-3 w-3 bg-black rounded-full"></span>
              <span className="h-3 w-3 bg-black rounded-full ml-1"></span>
            </span>
            MONTHLY CLOSING
          </div>
        </div>


        {/* Tab di navigazione */}
        <nav className="flex  gap-1">

          <Button variant="ghost">
            <Link to={'/tasks'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isListPath ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
              <ListIcon /> Tasks
            </Link>
          </Button>


          <Button variant="ghost" >
            <Link search={{
              year: closingDate.year,
              month: closingDate.month, // Months are 0-indexed in JS
              source: 'personal'
            }}
              to={'/summary'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isSummaryPath ? "border-gray-900 text-gray-900 " : "border-transparent text-gray-500")}>
              <SummaryIcon /> Summary
            </Link>
          </Button>
          {
            roles?.isClevel &&
            <Button variant="ghost" >
              <Link
                search={{
                  year: closingDate.year,
                  month: closingDate.month, // Months are 0-indexed in JS
                }}
                to={'/global-summary'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isGlobalSummary ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
                <ReportIcon /> Global summary
              </Link>
            </Button>
          }
          <Button variant="ghost" >
            <Link
              search={{
                year: closingDate.year,
                month: closingDate.month, // Months are 0-indexed in JS
              }}
              to={'/key-deadline'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isDeaadlineCorporate ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
              <FactoryIcon /> Key Deadline
            </Link>
          </Button>

          <Button variant="ghost" >
            <Link to={'/report'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isReportPath ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
              <DownloadIcon /> Download
            </Link>
          </Button>


          {
            roles.isAdmin && <Button variant="ghost" >
              <Link to={'/users'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isUsersPath ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
                <UserIcon /> Users
              </Link>
            </Button>
          }
          {
            roles.isAdmin && <Button variant="ghost" >
              <Link to={'/manage-tasks'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isManageTasksPath ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
                <ListTodoIcon /> Manage Tasks
              </Link>
            </Button>
          }
          {
            roles.isAdmin &&
             <Button variant="ghost" >
              <Link to={'/import'} className={cn('flex items-center text-base gap-2 px-1 py-2 border-b-3 transition-colors', isUpload ? "text-gray-900 border-gray-900" : "border-transparent text-gray-500")}>
                <UploadIcon /> Import
              </Link>
            </Button>
          }
        </nav>
        
      </div>


      {/* Icone azioni */}
      <div className="flex items-center ">
        {/* <Button variant="ghost" className="text-gray-600 hover:text-gray-900">
          <BellIcon className="size-7" />
        </Button>
        <Button variant="ghost" className="text-gray-600 hover:text-gray-900">
          <SettingsIcon className="size-7" />
        </Button> */}
        <HasOverdue />
        <ProfileMenu />
      </div>
    </div>
  );
};

